import {useEffect,useState} from "react";
const money=v=>new Intl.NumberFormat("pt-BR",{style:"currency",currency:"BRL"}).format(v||0);
const day=v=>typeof v==="string"&&/^\d{4}-\d\d-\d\d$/.test(v)?v
  :new Intl.DateTimeFormat("en-CA",{timeZone:"America/Sao_Paulo"}).format(new Date(v));
const labels={lead:"Lead",prospeccao:"Prospecção",porta:"Venda direta (Atendimento)"};
export default function DashboardOriginCards({Card,storeId,consultantId,periodRange,heading,
  stores=[],sales=[],onOpen,legacyBreakdown}){
  const [state,setState]=useState({loading:true}),[reload,setReload]=useState(0);
  const from=periodRange?.from?day(periodRange.from):"2026-10-01";
  const to=[periodRange?.to?day(periodRange.to):day(Date.now()),day(Date.now())].sort()[0];
  const storeIds=storeId?String(storeId):"1,2,3,4";
  useEffect(()=>{
    const controller=new AbortController();let retry,attempts=0;
    if(to<"2026-10-01"){
      setState({data:{unsupported:true}});
      return()=>controller.abort();
    }
    setState({loading:true});
    async function load(){
      attempts++;
      try{
        const query=new URLSearchParams({dashboard:"1",storeIds,from,to});
        if(consultantId)query.set("consultantId",String(consultantId));
        const response=await fetch(`/api/crm/sales-origin-report?${query}`,{
          credentials:"same-origin",cache:"no-store",signal:controller.signal});
        if(!response.ok)throw Error("unavailable");
        const data=await response.json();
        if(controller.signal.aborted)return;
        setState({data});
        if(data.pending&&attempts<3)retry=setTimeout(load,15000);
      }catch{if(!controller.signal.aborted)setState({error:true});}
    }
    load();return()=>{controller.abort();clearTimeout(retry);};
  },[storeIds,consultantId,from,to,reload]);
  const data=state.data?.unsupported&&legacyBreakdown
    ?{...state.data,summary:legacyBreakdown}:state.data;
  const open=key=>{
    if(data.unsupported){
      onOpen?.(labels[key],sales.filter(s=>(s.origin==="Lead"?"lead":s.origin==="Prospecção"?"prospeccao":"porta")===key));
      return;
    }
    const selected=(data.rows||[]).filter(r=>r.dashboardBucket===key).map(r=>{
      const id=`lift:${r.storeId}:${r.orderId}`;
      return {...(sales.find(s=>s.id===id)||{id,source:"LIFT",recordType:"lift",
        name:`Pedido #${r.orderId}`,storeId:r.storeId,consultantId:r.consultantId,
        value:r.valueCents/100,saleDate:r.date}),origin:labels[key]};
    });
    onOpen?.(labels[key],selected);
  };
  return <div aria-label={heading||"Cartões de origem das vendas"}>
    {heading&&<div style={{display:"flex",justifyContent:"space-between",gap:12,flexWrap:"wrap",marginBottom:12}}>
      <div style={{fontWeight:800,fontSize:16,color:"#1E293B"}}>{heading}</div>
      {data?.summary&&<div style={{fontSize:13,fontWeight:700,color:"#16A34A"}}>{money(data.summary.totalValue)} · {data.summary.totalQtd} vendas · {money(data.summary.ticketMedio)}</div>}
    </div>}
    {state.loading&&<p role="status">Carregando cartões…</p>}
    {data?.pending&&<p role="status">Preparando a atualização dos cartões, sem presumir valores.</p>}
    {data?.unsupported&&!legacyBreakdown&&<p>Cruzamento histórico disponível desde 01/10/2026.</p>}
    {state.error&&<p role="alert">Não foi possível consultar os cartões agora.</p>}
    {(state.error||data?.pending)&&<button onClick={()=>setReload(n=>n+1)}>Consultar novamente</button>}
    {data?.summary&&<>
      {data.stale&&<p role="status">Atualização pendente; exibindo o último cálculo salvo.</p>}
      {!!data.customerWarnings&&<p role="status">Há cadastros LIFT pendentes; o cruzamento pode estar incompleto.</p>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))",gap:10,marginBottom:14}}>
        <Card icon="📥" label="Lead" color="#2563EB" data={data.summary.lead} onClick={()=>open("lead")}/>
        <Card icon="🔎" label="Prospecção" color="#F59E0B" data={data.summary.prospeccao} onClick={()=>open("prospeccao")}/>
        <Card icon="🏪" label={labels.porta} color="#7C3AED" data={data.summary.porta} onClick={()=>open("porta")}/>
      </div>
      {!!stores.length&&!!data.stores?.length&&<><div style={{fontSize:11,fontWeight:700,color:"#64748B",marginBottom:6}}>Resumo por loja</div>
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          {(data.stores||[]).map(s=><div key={s.storeId} style={{background:"#F8FAFC",border:"1px solid #E2E8F0",borderRadius:10,padding:"10px 12px"}}>
            <div style={{display:"flex",justifyContent:"space-between",gap:8,flexWrap:"wrap",marginBottom:6}}>
              <strong>{stores.find(v=>Number(v.id)===s.storeId)?.name||`Loja ${s.storeId}`}</strong>
              <span>{money(s.totalValue)} · {s.totalQtd} vendas</span>
            </div>
            <div style={{display:"flex",gap:14,flexWrap:"wrap",fontSize:11.5}}>
              {["lead","prospeccao","porta"].map(k=><span key={k}>{labels[k]}: <strong>{money(s[k].value)}</strong> ({s[k].qtd} de {s[k].arrived}, {s[k].conv==null?"—":`${s[k].conv}%`})
                {k==="lead"&&s.lead.probableCount>0&&<small style={{display:"block"}}>+ {money(s.lead.probableValue)} prováveis</small>}
              </span>)}
            </div>
          </div>)}
        </div></>}
    </>}
  </div>;
}
